import { SimpleGrid } from 'app/agriculture/components/SimpleGrid/SimpleGrid';
import { StatDisplay } from 'app/agriculture/components/StatDisplay/StatDisplay';
import { StatWithDirection } from 'app/agriculture/components/StatWithDirection/StatWithDirection';
import {
    HumidityIcon,
    LightIcon,
    PressureIcon,
    RainIcon,
    TemperatureIcon,
    WindIcon,
} from 'app/agriculture/icons';
import { convertMPStoKMPH } from 'app/agriculture/utils';
import { useContext } from 'react';
import { DeviceDetailContext } from 'app/agriculture/routes/Devices/DeviceDetails/context/DeviceDetailContextProvider';
import { useSnapshot } from 'app/agriculture/queries/snapshots/useSnapshot';

export function WeatherDisplay() {
    const { device } = useContext(DeviceDetailContext);
    const {
        illuminance,
        uvIndex,
        temperature,

        humidity,
        deltaRainfall,
        absPressure,

        windSpeed,
        gustSpeed,
        windDirection,
    } =
        useSnapshot({
            snapshotType: 'Weather',
            parentId: device.id,
        }) ?? {};

    return (
        <SimpleGrid className="WeatherDisplay" columns={3}>
            <StatDisplay
                Icon={TemperatureIcon}
                name="Temperature"
                value={temperature}
                unit="°C"
                decimalPlaces={1}
            />
            <StatDisplay
                Icon={LightIcon}
                name="Illuminance"
                value={illuminance}
                unit="lux"
                decimalPlaces={1}
            />
            <StatDisplay Icon={LightIcon} name="UV Index" value={uvIndex} />

            <StatDisplay
                Icon={HumidityIcon}
                name="Humidity"
                value={humidity}
                unit="%"
                decimalPlaces={1}
            />
            <StatDisplay
                Icon={RainIcon}
                name="New Rainfall"
                value={deltaRainfall}
                unit="mm"
                decimalPlaces={1}
            />
            <StatDisplay
                Icon={PressureIcon}
                name="ABS Pressure"
                value={absPressure}
                unit="hPa"
                decimalPlaces={1}
            />

            <StatWithDirection
                direction={windDirection}
                Icon={WindIcon}
                name="Wind Speed"
                value={convertMPStoKMPH(windSpeed)}
                unit="km/h"
            />
            <StatDisplay
                Icon={WindIcon}
                name="Gust Speed"
                value={convertMPStoKMPH(gustSpeed)}
                unit="km/h"
            />
        </SimpleGrid>
    );
}
